import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBh7Dye2ZyoZgB77V8Ztj3knUKc4FIInLM",
  authDomain: "kara-immobilier-service.firebaseapp.com",
  projectId: "kara-immobilier-service",
  storageBucket: "kara-immobilier-service.firebasestorage.app",
  messagingSenderId: "911912556742",
  appId: "1:911912556742:web:b2d884afbfc06c3ac0dfc7",
  measurementId: "G-R4R9NP9Q7D",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);